<template>
    <div>
        <headers :show="show" :activeIndex="-1"></headers>
        <div class="zong">
            <div class="zong-1">
                <div class="title">
                    绿萝分发支持那些平台？
                </div>
                <div class="time">
                    发表时间：2020-10-17 02:20
                </div>
                <div class="list">
                    绿萝分发兼职2024年10月，支持近70+平台，新平台新功能持续开发中，现支持平台如下所示
                    <div class="list1">
                        (因咨询具有时效性，会新增、维护、下架部分平台，世纪请以软件内-编辑界面右侧平台列表为准)
                    </div>

                </div>

            </div>
            <div class="zong-2">
                <div class="zong-2-1">
                    <div class="title">
                        图文一键发布平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/11.png" alt="">
                                <div class="zi">微信公众号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/2.png" alt="">
                                <div class="zi">头条号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/3.png" alt="">
                                <div class="zi">百家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/4.png" alt="">
                                <div class="zi">企鹅号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/5.png" alt="">
                                <div class="zi">大鱼号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/6.png" alt="">
                                <div class="zi">一点号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/23.png" alt="">
                                <div class="zi">搜狐号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/60.png" alt="">
                                <div class="zi">网易号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪微博</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/61.png" alt="">
                                <div class="zi">小红书</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/8.png" alt="">
                                <div class="zi">简书号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/9.png" alt="">
                                <div class="zi">雪球号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/55.png" alt="">
                                <div class="zi">知乎</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/54.png" alt="">
                                <div class="zi">哔哩哔哩</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/15.png" alt="">
                                <div class="zi">新浪看点</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/21.png" alt="">
                                <div class="zi">快传号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/10.png" alt="">
                                <div class="zi">大风号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/1.png" alt="">
                                <div class="zi">AcFun</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zong-2-1">
                    <div class="title">
                        动态/图文笔记一键发布平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/57.png" alt="">
                                <div class="zi">抖音</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/2.png" alt="">
                                <div class="zi">头条号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/3.png" alt="">
                                <div class="zi">百家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/20.png" alt="">
                                <div class="zi">爱奇艺号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/53.png" alt="">
                                <div class="zi">快手</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/6.png" alt="">
                                <div class="zi">一点号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/55.png" alt="">
                                <div class="zi">知乎</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/60.png" alt="">
                                <div class="zi">网易号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪微博</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/61.png" alt="">
                                <div class="zi">小红书</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="zong-2-1">
                    <div class="title">
                        视频一键发布平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/11.png" alt="">
                                <div class="zi">微信公众号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/2.png" alt="">
                                <div class="zi">头条号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/3.png" alt="">
                                <div class="zi">百家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/4.png" alt="">
                                <div class="zi">企鹅号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/5.png" alt="">
                                <div class="zi">大鱼号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/6.png" alt="">
                                <div class="zi">一点号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/12.png" alt="">
                                <div class="zi">搜狐号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/60.png" alt="">
                                <div class="zi">网易号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪微博</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/61.png" alt="">
                                <div class="zi">小红书</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/56.png" alt="">
                                <div class="zi">微信视频号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/14.png" alt="">
                                <div class="zi">西瓜视频</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/55.png" alt="">
                                <div class="zi">知乎</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/54.png" alt="">
                                <div class="zi">哔哩哔哩</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/15.png" alt="">
                                <div class="zi">新浪看点</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/16.png" alt="">
                                <div class="zi">皮皮虾</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/17.png" alt="">
                                <div class="zi">微视</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/1.png" alt="">
                                <div class="zi">AcFun</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/18.png" alt="">
                                <div class="zi">美拍</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/19.png" alt="">
                                <div class="zi">拼多多</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/20.png" alt="">
                                <div class="zi">爱奇艺号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/53.png" alt="">
                                <div class="zi">快手</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/21.png" alt="">
                                <div class="zi">快传号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/22.png" alt="">
                                <div class="zi">腾讯视频</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/57.png" alt="">
                                <div class="zi">抖音</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/23.png" alt="">
                                <div class="zi">搜狐视频</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zong-2-1">
                    <div class="title">
                        仅支持纯账号管理平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/24.png" alt="">
                                <div class="zi">美柚</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/25.png" alt="">
                                <div class="zi">豆瓣</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪博客</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/26.png" alt="">
                                <div class="zi">易车号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/27.png" alt="">
                                <div class="zi">车家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/28.png" alt="">
                                <div class="zi">360图书馆</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/29.png" alt="">
                                <div class="zi">美团</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/30.png" alt="">
                                <div class="zi">百度贴吧</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/31.png" alt="">
                                <div class="zi">好看视频</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/32.png" alt="">
                                <div class="zi">百度知道</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/33.png" alt="">
                                <div class="zi">快看点</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/34.png" alt="">
                                <div class="zi">虎牙</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/35.png" alt="">
                                <div class="zi">斗鱼</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/36.png" alt="">
                                <div class="zi">什么值得买</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/37.png" alt="">
                                <div class="zi">CSDN</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/38.png" alt="">
                                <div class="zi">太平洋号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/39.png" alt="">
                                <div class="zi">宝宝知道</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/40.png" alt="">
                                <div class="zi">宝树号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/41.png" alt="">
                                <div class="zi">淘宝光合</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/42.png" alt="">
                                <div class="zi">腾讯看点</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/43.png" alt="">
                                <div class="zi">美篇</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/44.png" alt="">
                                <div class="zi">DOU+
                                </div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/45.png" alt="">
                                <div class="zi">京东达人</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/46.png" alt="">
                                <div class="zi">芒果吧</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/47.png" alt="">
                                <div class="zi">希腊玛雅</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/48.png" alt="">
                                <div class="zi">QQ短视频</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/57.png" alt="">
                                <div class="zi">抖音直播</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/49.png" alt="">
                                <div class="zi">波洞</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/50.png" alt="">
                                <div class="zi">抖音企业号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/51.png" alt="">
                                <div class="zi">支付宝</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zong-2-1">
                    <div class="title">
                        评论支持聚合管理平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/57.png" alt="">
                                <div class="zi">抖音</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/2.png" alt="">
                                <div class="zi">头条号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/3.png" alt="">
                                <div class="zi">百家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/54.png" alt="">
                                <div class="zi">哔哩哔哩</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/53.png" alt="">
                                <div class="zi">快手</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/11.png" alt="">
                                <div class="zi">微信公众号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/55.png" alt="">
                                <div class="zi">知乎</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/14.png" alt="">
                                <div class="zi">西瓜视频</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪微博</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/61.png" alt="">
                                <div class="zi">小红书</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/56.png" alt="">
                                <div class="zi">微信视频号</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zong-2-1">
                    <div class="title">
                        私信支持聚合管理平台
                    </div>
                    <div class="zhichi">
                        <div class="zhich-1" style="padding-left: 130px;">
                            <div class="imgg">
                                <img src="../assets/supportPlatform/57.png" alt="">
                                <div class="zi">抖音</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/2.png" alt="">
                                <div class="zi">头条号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/3.png" alt="">
                                <div class="zi">百家号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/54.png" alt="">
                                <div class="zi">哔哩哔哩</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/56.png" alt="">
                                <div class="zi">微信视频号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/11.png" alt="">
                                <div class="zi">微信公众号</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/55.png" alt="">
                                <div class="zi">知乎</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/7.png" alt="">
                                <div class="zi">新浪微博</div>
                            </div>
                            <div class="imgg">
                                <img src="../assets/supportPlatform/61.png" alt="">
                                <div class="zi">小红书</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="butong" style="display: flex;margin-top: 60px;margin-left: 150px;gap: 400px;">
                    <div class="imgg">
                        <div class="butong-title">
                            评论自动回复
                        </div>
                        <div class="butong-imgg" style="margin-top: 20px;">
                            <img src="../assets/supportPlatform/57.png" alt=""></img>
                            <div class="zi">抖音</div>
                        </div>
                    </div>
                    <div class="imgg">
                        <div class="butong-title">
                            私信自动回复
                        </div>
                        <div class="butong2">
                            <div class="butong-imgg">
                                <div class="butong-1">
                                    <img src="../assets/supportPlatform/58.png" alt=""></img>
                                    <div class="zi">抖音企业号</div>
                                </div>

                            </div>
                            <div class="butong-imgg">
                                <div class="butong-1">
                                    <img src="../assets/supportPlatform/58.png" alt=""></img>
                                    <div class="zi">抖音企业号工号</div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <footers></footers>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import footers from '../router/components/footer/footer.vue';
import headers from '../router/components/header/header.vue';

const show = ref(true);

onMounted(() => {
});
</script>

<style lang='less' scoped>
.zong {
    width: 80%;
    margin: 0 auto;
    padding-top: 60px;

    img {
        width: 80px;
        height: 80px;
    }

    .zong-1 {
        display: flex;
        flex-direction: column;
        gap: 40px;

        .title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 32px;
            color: #333333;
            line-height: 38px;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }

        .time {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 15px;
            color: #666666;
            line-height: 18px;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }

        .list,
        .list1 {
            margin: 0 auto;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }

        .list1 {
            margin-top: 10px;
        }

    }

    .zong-2 {
        .zong-2-1 {
            margin-top: 60px;

            .title {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
                font-size: 24px;
                line-height: 28px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                color: #6358ED;
            }

            .zhichi {
                width: 80%;
                padding-top: 40px;
                margin: 0 auto;


                .zhich-1 {
                    padding-left: 30px;
                    display: flex;
                    gap: 20px;
                    flex-wrap: wrap;
                    text-align: center;
                    justify-content: flex-start;

                    .imgg {
                        margin-top: 20px;

                        .zi {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            line-height: 16px;
                            text-align: center;
                            font-style: normal;
                            text-transform: none;
                        }
                    }
                }
            }
        }

        .butong {
            width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding-bottom: 40px;

            .imgg {
                .butong-title {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                    color: #6358ED;
                }

                .butong2 {
                    margin-top: 20px;
                    display: flex;
                    gap: 20px;
                }

                .zi {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 16px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }
            }
        }
    }


}
</style>